import axios from 'axios';

export const authAxios = axios.create({
    baseURL: process.env.REACT_APP_SERVER_URL,
    headers: {'Content-Type' : 'application/json'}
});

const fetcher = async (url:string) => await authAxios.get(url).then((res) => res.data);